/**
 * ルール保存時の入力検証を提供する。
 * アドレス条件がある場合は、空でないアドレスの指定を必須とする。
 */
import { z } from 'zod'
import type { ActionEditRuleDraft } from './types'

/** 移動元・移動先の条件には、空文字を含まないアドレスを1件以上必要とする。 */
const transferAddressesSchema = z.array(z.string().trim().min(1)).min(1)

/**
 * ルールを保存できない場合の入力エラーを返す。
 * @param params 保存対象の draft を受け取る。
 * @returns 入力エラーの説明を返す。保存可能な場合は undefined を返す。
 */
export const getActionEditRuleValidationError = ({
  draft,
}: {
  readonly draft: ActionEditRuleDraft
}): string | undefined => {
  const { transfer } = draft.conditions
  if (
    transfer !== undefined &&
    !transferAddressesSchema.safeParse(transfer.value).success
  ) {
    return 'アドレスを1件以上指定するか、条件を削除してください。'
  }
  return undefined
}
